module.exports = __webpack_public_path__ + "img/buildings.7212c870.jpg";